
import { Dumbbell } from "lucide-react";
import { ButtonColorful } from "@/components/ui/button-colorful";
import { useNavigate } from "react-router-dom";

export function EmptyProgramState() {
  const navigate = useNavigate();
  
  return (
    <div className="flex flex-col items-center justify-center p-8 text-center space-y-4">
      <div className="bg-white/10 p-4 rounded-full">
        <Dumbbell className="h-8 w-8 text-white" />
      </div>
      <h3 className="text-xl font-semibold text-white">No programs yet</h3>
      <p className="text-white/70 max-w-sm">
        Create your first program to start offering structured training to your clients
      </p>
      <ButtonColorful 
        label="Create Your First Program"
        className="mt-4"
        onClick={() => navigate('/create-program')}
      />
    </div>
  );
}
